<script setup>
import { Head, Link } from "@inertiajs/vue3";
import AppLayout from "@/Layouts/AppLayout.vue";
</script>

<template>
    <Head>
        <title>Gift no longer available | Gift Hero</title>
        <meta name="robots" content="noindex" />
    </Head>
    <AppLayout>
        <div
            class="container-wide stacked-children whitespace-bottom whitespace-top"
        >
            <div data-layout="module" data-layout-options="gutters wrap-items">
                <div
                    data-layout="module__item"
                    data-layout-width="one-whole c-one-quarter"
                >
                    <div class="copy-block"></div>
                </div>
                <div
                    data-layout="module__item"
                    data-layout-width="one-whole c-one-half"
                >
                    <div class="copy-block">
                        <h1>This gift is no longer available</h1>
                        <p>
                            This gift has been deleted, so it can no longer be
                            viewed.
                        </p>
                        <p>
                            <Link
                                href="/"
                                class="button is-primary is-rounded is-bold has-shadow"
                            >
                                Return to Gift Hero
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>
